<template>
  <div class="font-14 color-555 learn-wrap">
    <ul class="learn-list">
      <li v-for="(item, index) in list" :key="index">
        <div>
          <div class="font-20 learn-list-title">{{ item.title }}</div>
          &lt;!&ndash;
          <div class="events-list-desc">{{ item.desc }}</div>
          &ndash;&gt;
          <div class="learn-list-btn">
            <span>{{ item.btn }}</span>
          </div>
          <div class="learn-more">
            <router-link :to="{ name: item.redirectLink }">{{ $t('about.learnMore') }}</router-link>
          </div>
        </div>
      </li>
    </ul>
  </div>
</template>

<style scoped>
.learn-wrap {
  padding: 50px 0;
}

.learn-title {
  color: #fff;
  font-size: 30px;
  text-align: center;
  padding-top: 65px;
  padding-bottom: 6px;
}

.learn-view-all {
  font-size: 14px;
  color: #fff;
  text-align: center;
}

.learn-list {
  display: flex;
  flex-direction: row;
  justify-content: center;
  flex-wrap: wrap;
  padding: 0 50px;
}

.learn-list > li {
  padding: 28px 41px 25px;
  background-color: #fff;
  border-radius: 10px;
  margin: 16px;
  flex-basis: 400px;
}

.learn-list-icon {
  /* flex: 0 0 74px; */
  margin-right: 15px;
}

.learn-list-title {
  font-weight: bold;
  padding-bottom: 15px;
}
.learn-list-desc {
  font-size: 14px;
  padding-bottom: 25px;
}
.learn-list-btn {
  font-size: 14px;
  line-height: 19px;
  opacity: 1;
  display: flex;
  align-items: center;
  user-select: none;
  padding-bottom: 7px;
}
.learn-list-btn img {
  margin-left: 10px;
}

.learn-more {
  font-size: 14px;
  color: rgba(30, 73, 172, 1);
  text-decoration: underline;
  user-select: none;
}

.learn-view-all span {
  cursor: pointer;
}

@media screen and (max-width: 576px) {
  .learn-wrap {
    padding: 30px 0;
  }

  .learn-list {
    padding: 0 20px;
  }
}
</style>

<script>
export default {
  name: 'LearnMore',
  components: {},
  data() {
    return {
      currentCoin: 'GRX',
      list: [
        {
          title: this.$t('landing.think.sec.1'),
          btn: this.$t('landing.think.desc.1'),
          flag: 1,
          redirectLink: 'affiliate'
          // desc: 'Leverage on our sophisticated IB platform structure to potentially grow your market',
        },
        {
          title: this.$t('landing.think.sec.2'),
          btn: this.$t('landing.think.desc.2'),
          flag: 2,
          redirectLink: 'trading-fee'
          // desc: 'Leverage on our sophisticated IB platform structure to potentially grow your market',
        }
      ]
    };
  },
  methods: {
    redirectTo(flag) {
      if (flag === 1) {
        this.$router.replace({ name: '' });
      }
    }
  }
};
</script>
